<template>
  <v-card class="b-dark">
    <v-card-text>
      <div class="d-flex ga-5">
        <div>
          <img class="item-card-icons" src="@/assets/images/folder-icon.svg" />
        </div>
        <div class="d-flex flex-column ga-1 w-100">
          <div class="d-flex justify-space-between w-100 align-center">
            <h4>{{ getJobName(jobPreferences.WorkingPosition) }}</h4>
            <div class="d-flex ga-2">
              <v-btn v-if="!isHiringmanager" icon="mdi-pen" class="c-black b-white" :disabled="loading" @click="edit" />
              <v-btn v-if="!isHiringmanager" icon="mdi-delete" class="c-black b-white" :disabled="loading" @click="remove" />
            </div>
          </div>
          <span class="f-body-1">{{ jobPreferences.SeiorityLevel }} - {{ jobPreferences.PositionExperienceYear }} Years Experience</span>
          <span class="f-body-1 mt-5" v-if="jobPreferences.Amount && jobPreferences.Amount > 0">${{ jobPreferences.Amount }} per Hour</span>
          <div class="mt-5 d-flex flex-column ga-1" v-if="jobPreferences.PreferredLocation && jobPreferences.PreferredLocation.length > 0">
            <span class="f-body-1 mb-2">Location:</span>
            <div class="d-flex ga-3 flex-wrap">
              <v-chip v-for="(item, index) in jobPreferences.PreferredLocation" :key="index" class="b-charcoal">{{ item }}</v-chip>
            </div>
          </div>
          <div class="mt-5 d-flex flex-column ga-1">
            <span class="f-body-1 mb-2">Employment Type:</span>
            <div class="d-flex ga-3 flex-wrap">
              <v-chip v-for="(item, index) in jobPreferences.EmploymentType" :key="index" class="b-charcoal">{{ item }}</v-chip>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: ["jobPreferences", "jobTitles", "loading", "isHiringmanager"],
  data() {
    return {};
  },
  methods: {
    getStringOfArray(array: string[]) {
      return array.join(", ");
    },
    getJobName(id: any) {
      var findJobTitle = this.jobTitles.find((item: any) => item.id == id);
      if (findJobTitle) {
        return findJobTitle.Name;
      }
    },
    edit() {
      this.$emit("edit");
    },
    remove() {
      this.$emit("remove");
    },
  },
  mounted() {},
  watch: {},
});
</script>
<style lang="scss"></style>
